<template>
  <div class="relative z-backdrop">
    <div class="fixed w-full h-full top-0 left-0 z-backdrop bg-black/40"></div>
    <div v-click-outside="clickOutside"
         class="fixed z-modal top-0 bottom-0 left-0 right-0 xl:top-1/2 xl:left-1/2 xl:-translate-x-1/2
                xl:-translate-y-1/2 xl:w-[630px] xl:h-[500px]">
      <div class="w-full h-full pt-[65px] px-3.5 pb-[110px] bg-zt-normal rounded-zt shadow-around flex flex-col
                  justify-start items-stretch">
        <div class="absolute top-0 w-full h-[50px] left-0">
          <h3 class="pl-3.5 no-default-style m-0 text-base font-semibold w-full my-3">Zgłoś {{ titleType }}</h3>
          <div class="x-close-modal" @click="closeModal"></div>
          <hr class="border-zt-main xl:border-zt-light">
        </div>
        <div class="w-full mb-4" v-if="type !== 'comment' && type !== 'coupon' && type !== 'betDiscussion'">
          <h4 class="no-default-style w-full text-sm font-semibold mb-2">Powód</h4>
          <FormSelect class="w-full bg-zt-main rounded-zt text-xs" close-on-second-click
            :options="reasonOptions" placeholder="Wybierz powód" :editable="false"
            :model="reason"/>
        </div>
        <div class="w-full grow flex flex-col">
          <h4 class="no-default-style w-full text-sm font-semibold mb-2">Więcej szczegółów</h4>
          <textarea maxlength="1000"
                    class="resize-none rounded-zt bg-zt-main text-xs w-full grow px-4 py-3.5
                           placeholder:font-semibold placeholder:opacity-40 placeholder:text-[#DFDFDF] xl:h-[200px]"
                    placeholder="Opisz powód" v-model="description"></textarea>
        </div>
        <div class="absolute left-1/2 -translate-x-1/2 w-full flex flex-col items-center justify end bottom-5" >
          <button @click="sendReport" class="zt-button w-[330px] mb-2.5 uppercase">Wyślij</Button>
          <Transition name="fade-slide">
            <div v-if="errorMessage !== ''"
                 class="text-[#F00] text-sm text-center w-full">
              {{ errorMessage }}
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormSelect from '../FormSelect.vue';
import utils_mixin from '../../mixins/utils_mixin';
import { Notice } from '../../../assets/js/Notice';

export default {
  name: 'ReportModal',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    FormSelect,
  },
  props: {
    id: Number,
    type: String,
    linkToReportedItem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      reason: {
        string: '',
      },
      description: '',
      errorMessage: '',
      clickOutside: {
        handler: this.closeModal,
        events: ['touchend', 'mouseup']
      }
    };
  },
  computed: {
    titleType() {
      if (this.type === 'bet') {
        return 'typ';
      } else if (this.type === 'comment') {
        return 'komentarz';
      } else if (this.type === 'profile') {
        return 'profil';
      } else if (this.type === 'coupon') {
        return 'kupon';
      } else if (this.type === 'betDiscussion') {
        return 'wpis';
      } else {
        return '';
      }
    },
    reasonOptions() {
      if (this.type === 'bet') {
        return [
          'Zawyżony kurs',
          'Bardzo słaba analiza',
          'Nieodpowiednia godzina',
          'Nieodpowiednie rozliczenie',
          'Inny',
        ];
      } else if (this.type === 'profile') {
        return [
          'Spam/Reklama',
          'Oszustwo',
          'Inne',
        ];
      }
    },
  },
  methods: {
    emit(eventName) {
      if (eventName !== 'close') {
        this.$emit(eventName);
      }
      this.$emit('close');
    },
    closeModal() {
      this.emit('close');
    },
    sendReport() {
      if (this.reason.string === '' && this.type !== 'comment' && this.type !== 'coupon' && this.type !== 'betDiscussion') {
        this.errorMessage = 'Należy podać powód zgłoszenia';
        return;
      }
      if (this.description === '') {
        this.errorMessage = 'Należy dodać opis zgłoszenia';
        return;
      }

      const lastReportTimestamp = localStorage.getItem(`last-report-timestamp`);
      if (lastReportTimestamp != null && lastReportTimestamp >= new Date().getTime()) {
        this.errorMessage = 'Odczekaj chwilę przed przesłaniem kolejnego zgłoszenia';
        return;
      }

      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_add_user_report',
        id: this.id,
        type: this.type,
        reason: this.reason.string,
        description: this.description
      })
      .then(response => {
        if (response.data.success) {
          localStorage.setItem(`last-report-timestamp`, new Date().getTime() + 30000);
          const notificationContent = `Zgłoszenie zostało wysłane. ${this.reason.string === 'Zawyżony kurs' ?
              ' Weryfikacja zawyżonych kursów trwa dłużej niż innych zgłoszeń. Prosimy o cierpliwość' :
              ' Rozpatrzenie może chwilę potrwać. Prosimy o cierpliwość'}`;
          const dismissTime = {
            mobile: this.reason.string === 'Zawyżony kurs' ? 3000 : 2000,
            desktop: this.reason.string === 'Zawyżony kurs' ? 4500 : 3500
          }
          this.addInternalNotification(new Notice().setContent(notificationContent).setDismissTime(dismissTime));
          this.closeModal();
        }
      })
      .catch(error => {
        this.errorMessage = error.response.data.data;
      });
    },
  }
};
</script>

<style scoped>
  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: opacity 0.5s ease, height 0.5s ease;
  }
  
  .fade-slide-enter-from,
  .fade-slide-leave-to {
    height: 0;
    opacity: 0;
  }
  
  .fade-slide-enter-to,
  .fade-slide-leave-from {
    height: 20px;
    opacity: 100;
  }
</style>
